export {};
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-inlinesvg/esm/types.js
// module id = MMpf
// module chunks = 0